var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".star_svg__st3{fill:#35a4dd}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 598.3,
    cy: 259.7,
    r: 32.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M531.7 186.4c-.6-1.2-1.2-2.5-1.6-3.8l-18-42.2L407.4 387c-4.7 11.1-15.1 18.6-27.1 19.7l-266.1 23.6L316 605c9.1 7.9 13.1 20.1 10.4 31.8l-60.2 262.4 229.1-137.9c5.2-3.1 11-4.7 16.8-4.7 5.8 0 11.6 1.6 16.8 4.7l229.2 137.9L698.4 639c-2.7-11.6 1.3-23.8 10.2-31.7l201.5-176.8L645.2 408c-12-1-22.4-8.6-27.1-19.6l-11.2-26.2c-.6-1.3-1.2-2.6-1.7-3.9l-73.5-171.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.8 394.6c-4.1-12.4-15.1-21.1-28.1-22.2l-321.6-27.3-3.2-7.5-2.3-5.4c-5.5-10.2-16.3-17.2-28.7-17.2-18 0-32.6 14.6-32.6 32.6 0 3.8.6 7.4 1.8 10.8l1.7 3.9 11.2 26.2c4.7 11.1 15.2 18.6 27.1 19.6L910 430.6 708.5 607.4c-9 7.9-12.9 20.1-10.2 31.7L758 899.3 528.8 761.4c-5.2-3.1-11-4.7-16.8-4.7-5.8 0-11.6 1.6-16.8 4.7L266.1 899.3l60.2-262.4c2.7-11.7-1.3-24-10.4-31.8L114.3 430.2l266.1-23.6c12-1.1 22.4-8.6 27.1-19.7l104.7-246.6 18 42.2 1.6 3.8c5.4 10.7 16.4 18 29.1 18 18 0 32.6-14.6 32.6-32.6 0-3.5-.6-6.8-1.6-10l-2.4-5.5-47.6-111.6c-5.1-12-16.9-19.7-29.9-19.7s-24.8 7.8-29.9 19.8l-126.9 299-323 28.6c-13 1.2-24 10-28.1 22.4-4 12.4-.2 26 9.6 34.6l244.9 212.2-73 317.9c-2.9 12.7 2 25.9 12.6 33.6 10.6 7.7 24.7 8.3 35.8 1.5l278-167.3 277.9 167.3c5.2 3.1 11 4.7 16.8 4.7 6.7 0 13.4-2.1 19.1-6.2 10.6-7.7 15.5-20.9 12.6-33.6L766 643.5l244.4-214.3c9.8-8.6 13.5-22.3 9.4-34.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default ForwardRef;